import { Component, ViewEncapsulation } from '@angular/core';
import { AppConfigService } from '../../../app-config.service';

@Component({
  selector: 'app-indisponible',
  templateUrl: './indisponible.component.html',
  styleUrls: ['./indisponible.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class IndisponibleComponent {
  constructor(private readonly _appConfigService: AppConfigService) {}

  retourSommaire() {
    window.location.href = this._appConfigService.configData.contexteEnvironnement.urlRetour;
  }
}
